export default "__VITE_ASSET__044b5a59__"